export const SET_FILTERS = 'SET_FILTERS';
export const FETCH_ORDERS = 'FETCH_ORDRES';
export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const SET_LOADING = 'SET_LOADING';
export const FETCH_CUSTOMER = 'FETCH_CUSTOMER';
export const FETCH_DRIVERS = 'FETCH_DRIVERS';
export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION';
